import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Message, MessageTop, Header, HeaderContent } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _excluded = ["className", "header", "partner"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PartnerMessage = function PartnerMessage(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    header = _ref.header,
    partner = _ref.partner,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (typeof header !== 'string' || !header || !partner) {
    return false;
  }
  return /*#__PURE__*/jsx(Message, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    $partner: partner,
    children: /*#__PURE__*/jsxs(MessageTop, {
      $partner: partner,
      children: [/*#__PURE__*/jsx("img", {
        alt: partner,
        src: "https://img.nltg.com/image/upload/h_22,f_webp/web/partners/".concat(partner, ".png")
      }), /*#__PURE__*/jsx(Header, {
        $partner: partner,
        children: /*#__PURE__*/jsx(HeaderContent, {
          children: header
        })
      })]
    })
  }));
};
var PartnerMessage$1 = PartnerMessage;

export { PartnerMessage$1 as default };
//# sourceMappingURL=PartnerMessage.js.map
